import { render, staticRenderFns } from "./a-text-single-line.vue?vue&type=template&id=538265ce&"
import script from "./a-text-single-line.vue?vue&type=script&lang=js&"
export * from "./a-text-single-line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports